// This Component Will Return the Page Loader Of our Site
const PageLoader = _ => {

    return <div className="page-loader flex-center-element "><div className="loader text-center"></div></div>
    
}

export default PageLoader;